import { render, staticRenderFns } from "./ParcelGroupChangeDialog.vue?vue&type=template&id=62be4615&scoped=true"
import script from "./ParcelGroupChangeDialog.vue?vue&type=script&lang=js"
export * from "./ParcelGroupChangeDialog.vue?vue&type=script&lang=js"
import style0 from "./ParcelGroupChangeDialog.vue?vue&type=style&index=0&id=62be4615&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62be4615",
  null
  
)

export default component.exports